import styled from "styled-components";

export const Wrapper = styled.div``;

export const Index = styled.span`
  display: inline-block;
  width: 2.5rem;
  margin: 0 0 0.75rem 0;
  font-family: wipeout;
  font-size: 1.5rem;
  color: var(--color-orange);
`;
